import { render, staticRenderFns } from "./RinvPT.vue?vue&type=template&id=4f6be0a1&scoped=true"
import script from "./RinvPT.vue?vue&type=script&lang=js"
export * from "./RinvPT.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=4f6be0a1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6be0a1",
  null
  
)

export default component.exports